import {
    collection,
    query,
    getDocs,
    addDoc,
    deleteDoc,
    updateDoc,
    doc,
    where,
} from 'firebase/firestore';

import { db } from '../firebase/firebase';
import { RoscaOrder } from "../models/RoscaOrder";
import customerService from './customer.service';
import userService from './user.service';
import { normalizePhoneForOrder } from '../helpers/phone';

class RoscaOrdersService {
    constructor() {
        this.collection = 'roscas';
    }

    async createRoscaOrder(rosca) {
        // Normalize phone number to E.164 format
        if (rosca.phoneNumber) {
            try {
                rosca.phoneNumber = normalizePhoneForOrder(rosca.phoneNumber);
            } catch (error) {
                throw new Error(error.message || 'Invalid phone number format. Please correct the phone number.');
            }
        }

        // Find or create customer if customerId not provided
        let finalCustomerId = rosca.customerId;
        if (!finalCustomerId && rosca.phoneNumber) {
            try {
                const customer = await customerService.findOrCreate(rosca.phoneNumber, {
                    firstName: rosca.firstName,
                    lastName: rosca.lastName
                });
                finalCustomerId = customer.id;
                rosca.customerId = finalCustomerId;
            } catch (error) {
                console.error('Error finding/creating customer:', error);
            }
        }

        // Get store_id from current user
        const store_id = await userService.getUserStoreId();
        rosca.store_id = store_id;

        const collectionRef = collection(db, this.collection);
        const docRef = await addDoc(collectionRef, rosca.toJson());
        rosca.id = docRef.id;

        // Record order on customer
        if (finalCustomerId) {
            try {
                await customerService.recordOrder(finalCustomerId);
            } catch (error) {
                console.error('Error recording order on customer:', error);
            }
        }

        return rosca;
    }

    async fetchRoscas() {
        const userStoreId = await userService.getUserStoreId();
        const collectionRef = collection(db, this.collection);
        const q = query(collectionRef, where("store_id", "==", userStoreId));
        const querySnapshot = await getDocs(q);
        const roscas = [];
        querySnapshot.forEach((doc) => {
            roscas.push(RoscaOrder.fromFirebase(doc))
        });
        return roscas;
    }

    async deleteRoscaOrder(id) {
        // Implement deleteRoscaOrder
        const collectionRef = collection(db, this.collection);
        await deleteDoc(doc(collectionRef, id));
    }

    async togglePickedUp(id, pickedUp) {
        const docRef = doc(db, this.collection, id);
        await updateDoc(docRef, { pickedUp: !pickedUp });
    }

    async updateRoscaOrder(id, changes) {
        const docRef = doc(db, this.collection, id);
        await updateDoc(docRef, changes);
    }
}

const service = new RoscaOrdersService();
export default service;
